(() => {
  if (customElements.get('obd-code-library')) return;

  class ObdCodeLibrary extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.input = this.querySelector('[data-code-search]');
      this.clearButton = this.querySelector('[data-code-clear]');
      this.cards = Array.from(this.querySelectorAll('[data-code-card]'));
      this.visibleCount = this.querySelector('[data-visible-count]');
      this.totalCount = this.querySelector('[data-total-count]');
      this.totalSummary = this.querySelector('[data-total-summary]');
      this.emptyState = this.querySelector('[data-code-empty]');
      this.popularSearches = this.querySelector('.obd-library__popular');
      this.resultLabel = this.dataset.resultsLabel || 'codes shown';

      if (!this.input || !this.clearButton || !this.visibleCount || !this.emptyState) return;

      this.dataset.ready = 'true';
      this.handleInput = this.update.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);
      this.handleClear = this.reset.bind(this);
      this.handlePopularClick = this.onPopularClick.bind(this);

      this.input.addEventListener('input', this.handleInput);
      this.input.addEventListener('keydown', this.handleKeydown);
      this.clearButton.addEventListener('click', this.handleClear);
      this.popularSearches?.addEventListener('click', this.handlePopularClick);

      if (this.totalCount) this.totalCount.textContent = String(this.cards.length);
      this.totalSummary?.setAttribute('aria-label', `${this.cards.length} ${this.totalSummary.querySelector('span')?.textContent?.trim() || 'diagnostic guides'}`);
      this.update();
    }

    disconnectedCallback() {
      if (this.dataset.ready !== 'true') return;

      this.input?.removeEventListener('input', this.handleInput);
      this.input?.removeEventListener('keydown', this.handleKeydown);
      this.clearButton?.removeEventListener('click', this.handleClear);
      this.popularSearches?.removeEventListener('click', this.handlePopularClick);
      delete this.dataset.ready;
    }

    normalize(value) {
      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');
    }

    tokens(value) {
      return String(value || '').toUpperCase().match(/[A-Z0-9]+/g) || [];
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.reset();
    }

    onPopularClick(event) {
      const button = event.target.closest('[data-code-filter]');
      if (!button || !this.popularSearches.contains(button)) return;

      this.input.value = button.dataset.codeFilter || '';
      this.update();
      this.input.focus();
    }

    reset() {
      this.input.value = '';
      this.update();
      this.input.focus();
    }

    update() {
      const queryTokens = this.tokens(this.input.value).map((token) => this.normalize(token));
      let visible = 0;

      this.cards.forEach((card) => {
        const searchableValue = this.normalize(`${card.dataset.search || ''} ${card.textContent || ''}`);
        const matches = queryTokens.length === 0 || queryTokens.every((token) => searchableValue.includes(token));
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      this.clearButton.hidden = this.input.value.length === 0;
      this.visibleCount.textContent = String(visible);
      this.visibleCount.parentElement?.setAttribute('aria-label', `${visible} ${this.resultLabel}`);
      this.emptyState.hidden = visible !== 0;
    }
  }

  customElements.define('obd-code-library', ObdCodeLibrary);
})();
